import { Box, Button, Grid, Hidden, TextField } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import React, { useContext, useState } from "react";
import ImageUpload from "../../../components/common/imageUpload";
import FieldLabel from "../../../components/common/label";
import ApplicationContext from "../../../context/index";
import {
  isCopaymentSkippedForClaim,
  validateInputLength,
} from "../../../helpers/proposal";
import { useStyles } from "../indexFormStyles";
import EstimationUploadBtn from "../../../components/common/EstimationUploadBtn";

function EstimationForm({
  classes: { formGroup, textField },
  errorMessage,
  form,
  handleChange,
  isSearchCompleted,
  photoChangeHandler,
  refId = null,
  claimId = null,
  setGetImageData,
  setGetLength,
}) {
  const {
    state: { orderDetails = null },
  } = useContext(ApplicationContext);

  return (
    isSearchCompleted && (
      <Box direction="column" style={{ width: "100%" }}>
        {/* <Grid container spacing={2} className={!orderDetails ? "disabled" : ""}> */}
        <Grid container spacing={2}>
          <Grid container item md={5} direction="column">
            {!refId && !claimId && (
              <Box className={formGroup}>
                <FieldLabel
                  label={"Damage Details"}
                  fieldValue={""}
                  labelKey={"damage_details"}
                />
                <TextField
                  type={"text"}
                  id="outlined-margin-none"
                  name="damage_details"
                  className={textField}
                  helperText={errorMessage.damage_details}
                  value={form.damage_details}
                  onChange={handleChange}
                  multiline
                  minRows={3}
                />
              </Box>
            )}

            {isCopaymentSkippedForClaim(
              orderDetails?.claims[0]?.razorpay_order_id
            ) && (
              <Box className={formGroup}>
                <FieldLabel
                  label={"Copayment Amount"}
                  labelKey={"copayment_amount"}
                  tooltip={"Please collect this copayment amount from customer"}
                />
                <FieldLabel
                  label={`₹${Number(
                    orderDetails?.claims[0]?.copayment_amount
                  ).toLocaleString("en")}`}
                  fieldValue={""}
                  labelKey={""}
                  required={false}
                />
              </Box>
            )}

            <Box className={formGroup}>
              <FieldLabel
                label={"Estimate Amount"}
                fieldValue={""}
                labelKey={"estimate_amount"}
              />
              <TextField
                type={"number"}
                id="outlined-margin-none"
                name="estimate_amount"
                className={textField}
                helperText={errorMessage.estimate_amount}
                value={form.estimate_amount}
                onInput={validateInputLength}
                onChange={handleChange}
              />
            </Box>

            {!refId && !claimId && (
              <Box className={formGroup}>
                <FieldLabel label={"Aadhaar Photo"} fieldValue={""} />
                <ImageUpload
                  title="Add Photo"
                  photoChangeHandler={photoChangeHandler}
                  filename="aadhaar"
                />
              </Box>
            )}

            <Box className={formGroup}>
              <FieldLabel
                label={"Estimate Details"}
                fieldValue={""}
                labelKey={"estimate_details"}
              />
              <TextField
                type={"text"}
                id="outlined-margin-none"
                name="estimate_details"
                className={textField}
                helperText={errorMessage.estimate_details}
                value={form.estimate_details}
                onChange={handleChange}
                multiline
                // minRows={3}
              />
            </Box>

            <Box className={formGroup}>
              <FieldLabel
                label={"Job Sheet Number"}
                fieldValue={""}
                labelKey={"job_sheet_number"}
              />
              <TextField
                type={"text"}
                id="outlined-margin-none"
                name="job_sheet_number"
                className={textField}
                helperText={errorMessage.job_sheet_number}
                value={form.job_sheet_number}
                onInput={validateInputLength}
                onChange={handleChange}
              />
            </Box>
          </Grid>

          <Hidden smDown>
            <Grid container item md={2} direction="column"></Grid>
          </Hidden>

          <Grid container item md={5} direction="column">
            {!refId && !claimId && (
              <Box className={formGroup}>
                <FieldLabel label={"Damage Mobile Photo"} fieldValue={""} />
                <ImageUpload
                  title="Add Photo"
                  photoChangeHandler={photoChangeHandler}
                  filename="phone"
                />
              </Box>
            )}

            <Box className={formGroup}>
              <FieldLabel
                label={"Estimate Document (jpeg, png, and pdf)"}
                fieldValue={form.estimate}
              />
              <Button
              // data-tip={`Please upload estimate in pdf format for instant approval`}
              >
                <ImageUpload
                  title="Add Document"
                  photoChangeHandler={photoChangeHandler}
                  filename="estimate"
                />
              </Button>
            </Box>

            <Box className={formGroup}>
              <FieldLabel label={"Damage Mobile Photo"} fieldValue={""} />
              {/* <ImageUpload
                title="Add Photo"
                photoChangeHandler={photoChangeHandler}
                filename="phone"
              /> */}
              <EstimationUploadBtn {...{ setGetImageData, setGetLength }} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    )
  );
}

export default withStyles(useStyles, { withTheme: true })(EstimationForm);
